import { EventEmitter } from 'events';

class SectionsLibraryData extends EventEmitter{
  constructor(){
    super();

    this.sections = [];
    this.options = {};
  }

  setAllSections(sections){
    this.sections = sections;

    this.emit('change');
  }

  setAllOptions(options){
    this.options = options;

    this.emit('change');
  }

  getAllSections(){
    return this.sections;
  }
}

const sectionsLibraryData = new SectionsLibraryData;

export default sectionsLibraryData;



// WEBPACK FOOTER //
// ./src/helpers/SectionsLibraryData.js